/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Components.CrossReferences";
        /**
         * Component for display of cross references from a source document.
         * The requirement is pretty simple, using DataTable is probably overkill but it
         * may enable us to do clever things longer term.
         */
        class ComponentCrossReferences extends Widgets.ComponentBaseClass {
            constructor(core, container, parent) {
                super(core, container, parent);
                this._componentReady = false;
                this._displayPending = false;
                this._currentDocId = null;
                this._refList = [];
                this._currentFilter = "";
                // Access
                this.DocSelectedCallBack = null;
                // UI Components
                this._listHolder = null;
                this._loader = null;
                this._noRecords = null;
                this._dataList = null;
                this._storeHtml = (htmlData) => {
                    this._log.info("CrossReferencesComponent._storeHtml()");
                    ComponentCrossReferences.Html = htmlData;
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                };
                this.showRefsForDocument = (doc) => {
                    this._log.info("CrossReferencesComponent.showRefsForDocument()");
                    this._currentDocId = doc.ItemNum;
                    if (!this._componentReady) {
                        this._displayPending = true;
                        return;
                    }
                    else {
                        this._loadCrossReferences();
                    }
                };
                this.showRefsForDocumentId = (doc) => {
                    this._log.info("CrossReferencesComponent.showRefsForDocumentId()");
                    this._currentDocId = doc;
                    if (!this._componentReady) {
                        this._displayPending = true;
                        return;
                    }
                    else {
                        this._loadCrossReferences();
                    }
                };
                this._loadCrossReferences = () => {
                    this._log.info("CrossReferencesComponent._loadCrossReferences()");
                    this._core.Functions.showElement(this._loader);
                    this._core.Loader.genericServiceCall(`/Documents.svc/rest/GetRelatedDocuments/${this._currentDocId}`, this._receiveReferences, this._errorCallback, this._failCallback);
                };
                this._receiveReferences = (response) => {
                    this._log.info("CrossReferencesComponent._receiveReferences()");
                    if (response.hasOwnProperty('Documents') && response.Documents.length != null) {
                        this._refList = response.Documents;
                    }
                    else {
                        this._refList = [];
                    }
                    this._displayReferences();
                };
                this._displayReferences = () => {
                    this._log.info("CrossReferencesComponent._displayReferences()");
                    this._core.Functions.hideElement(this._loader);
                    this._core.Functions.hideElement(this._noRecords);
                    if (this._refList.length > 0) {
                        let listData = {
                            Items: []
                        };
                        let length = this._refList.length;
                        for (let i = 0; i < length; i++) {
                            let doc = this._refList[i];
                            let itemData = {
                                Id: doc.ItemNum.toString(10),
                                DisplayName: doc.Name
                            };
                            listData.Items.push(itemData);
                        }
                        this._dataList.displayData(listData);
                        this._dataList.filterItems(this._currentFilter);
                    }
                    else {
                        // Show no records if we've found nothing to show
                        this._core.Functions.showElement(this._noRecords);
                        this._dataList.clearList();
                    }
                };
                this._rowClicked = (id) => {
                    this._log.info("CrossReferencesComponent._rowClicked()");
                    if (this.DocSelectedCallBack) {
                        let docId = Number(id);
                        let doc = this._refList.find(d => d.ItemNum == docId);
                        if (doc)
                            this.DocSelectedCallBack(doc);
                    }
                };
                this.clearDisplay = () => {
                    this._log.info("CrossReferencesComponent.clearDisplay()");
                    this._dataList.clearList();
                };
                this.filterReferences = (search) => {
                    this._log.info("CrossReferencesComponent.filterReferences()");
                    this._currentFilter = search;
                    this._dataList.filterItems(search);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("CrossReferencesComponent::constructor");
                // But the html is static
                if (!ComponentCrossReferences.Html) {
                    core.Loader.getVersionedHTML('widgets/components/crossreferences.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
                else {
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                }
            }
            _present() {
                this._log.info("CrossReferencesComponent._present()");
                if (!this._readyToPresent) {
                    this._waitingToPresent = true;
                    return;
                }
                this._container.innerHTML = ComponentCrossReferences.Html;
                this._loader = this._container.querySelector('.wpt-hourglass');
                this._noRecords = this._container.querySelector('#crossRefComponentNoRecords');
                this._listHolder = this._container.querySelector('#crossRefComponentHolder');
                this._core.Helper.setElementTranslation(this._container.querySelector('#crossRefComponentLoading'), 'STR_WPT_LOADING');
                this._core.Helper.setElementTranslation(this._container.querySelector('#crossRefComponentNoRecordsLabel'), 'STR_WPT_NO_XREFS_FOUND');
                this._core.Helper.prepareHourglassIcon(this._loader);
                let listConfig = {
                    SelectItemCallback: this._rowClicked
                };
                this._dataList = new Widgets.ComponentDataList(this._core, this._listHolder, this._parent, listConfig);
                this._dataList.present();
                if (this._displayPending)
                    this._loadCrossReferences();
                this._componentReady = true;
            }
        }
        ComponentCrossReferences.Html = null;
        Widgets.ComponentCrossReferences = ComponentCrossReferences;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
